export default "__VITE_ASSET__DZ$B$IK0__"